import type * as Sentry from '@sentry/react-native';

type MobileReplayOptions = NonNullable<Parameters<typeof Sentry.mobileReplayIntegration>[0]>;

const mobileReplayOptions: MobileReplayOptions = {
  maskAllText: true,
  maskAllImages: true,
  enableViewRendererV2: true,
  enableFastViewRendering: true,
};

export { mobileReplayOptions };
